var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1592284169455,
    className: "icon",
    viewBox: "0 0 1024 1024",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M547.427249 757.898358v66.827461a31.227786 31.227786 0 0 1-35.599675 28.105007 31.227786 31.227786 0 0 1-35.599676-28.105007v-66.827461a82.441354 82.441354 0 1 1 71.511629 0z m371.922928-173.001933v-99.304358a99.304358 99.304358 0 0 0-101.802582-96.18158H206.107552A99.304358 99.304358 0 0 0 104.304971 485.592067v442.185445a98.992081 98.992081 0 0 0 101.802581 96.18158h611.440043a99.304358 99.304358 0 0 0 101.802582-96.18158v-31.227786h-133.342645V843.150213h133.342645v-71.823907h-133.342645V718.23907h133.342645v-79.943131h-133.342645v-53.399514z",
    "p-id": 5100
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.790909 253.56962A160.510818 160.510818 0 0 1 459.98945 93.683357h103.676248a160.510818 160.510818 0 0 1 160.510818 160.510818v112.420029h113.66914V218.5945a218.5945 218.5945 0 0 0-218.5945-218.5945H405.340825a218.5945 218.5945 0 0 0-218.5945 218.5945v146.458314h113.044584z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lock.168128be.svg";
export { ForwardRef as ReactComponent };